const emptyStringToNull = (value: string): null | string =>
  value === '' ? null : value;

export default emptyStringToNull;
